import { createPromiseClient } from '@bufbuild/connect';
import { ConnectTransportOptions } from '@bufbuild/connect-web';
import { LmsHomewokStudentAPIServiceV1 } from '@protos/learning_management/lms.hw.student.apis_connect';
import { ResponseStatusCodeFunction, lmsTransport, lmsTransportWithLogoutHandler } from './transports';

export const LmsHomewokStudentAPIServiceV1Client = createPromiseClient(
  LmsHomewokStudentAPIServiceV1,
  lmsTransport
);

//LmsHomewokStudentAPIServiceV1
export const useLmsHomewokStudentAPIServiceV1ClientWithStatusCodeHandler = (options: Partial<ConnectTransportOptions>, responseStatusCodeFunction: ResponseStatusCodeFunction) => createPromiseClient(
  LmsHomewokStudentAPIServiceV1,
  lmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
);
